import { render } from "./dashboardWorksview.vue?vue&type=template&id=9f7cff5c"
import script from "./dashboardWorksview.vue?vue&type=script&lang=js"
export * from "./dashboardWorksview.vue?vue&type=script&lang=js"

import "./dashboardWorksview.vue?vue&type=style&index=0&id=9f7cff5c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__